import React, { useEffect, useRef, useState } from "react";
import genStyles from "../../generale.module.css";
import ResultForm from "../../resultat/resultatForm";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { apiCollectionState, collectionsCurState, loadingState, repFileState, toastState, typeCollectionState, userDataState } from "../../../atoms/CollectionState";
import CollectionService from "../../../service/CollectionService";
import TooltipForm from "../../tooltipForm";
import FullScreenModal from "../../modalForm/fullScreenModal";
import DeleteCollectionForm from "../../collection/deleteCollectionForm";

export default function FileForm({objectCur,setEntites}) {    
    const fileInputRef = useRef(null);
    const [fileName, setFileName] = useState(null);        
    const setToast = useSetRecoilState(toastState);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortConfig, setSortConfig] = useState(null);
    const [fichierlist, setFichierlist] = useState([]);
    const setLoading = useSetRecoilState(loadingState);
    const api_collection = useRecoilValue(apiCollectionState);    
    const collectionRep = useRecoilValue(repFileState);
    const user_data = useRecoilValue(userDataState);      
    const [fileCur, setFileCur] = useState({}); 
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const collectioncur = useRecoilValue(collectionsCurState);
    const typeCollection = useRecoilValue(typeCollectionState);  
    
    const urlApi = api_collection + user_data.account.port + '/';
    const userAccountId = user_data.account.id;
    const userId = user_data.user.id;
    const firstRender = useRef(true);

    useEffect(() => {  
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        if(!showConfirmModal){
            loadListFile();
        }
    }, [showConfirmModal]);

    
    useEffect(() => {  
        loadListFile();
    }, []);

    const loadListFile = () => {
        const userid = objectCur.sogefi_operateur_creation;
        const entite_id = (objectCur.idnewbd && objectCur.idnewbd !== "null")
        ? parseInt(objectCur.idnewbd)
        : objectCur.id;
        if(userid && entite_id){
            CollectionService.getEntiteFile(urlApi,userid,entite_id).then((response) => {
                setFichierlist(response);
            });
        }
    };

    const uploadFile = async (file) => {
        if (!file) return;
    
        setLoading(true); 
        const formData = new FormData();
        formData.append("files[]", file); 
        formData.append("account_id", userAccountId); 
        formData.append("user_id", userId); 
        formData.append("id_annotation", objectCur.id); 
        const idToSend = (objectCur.idnewbd && objectCur.idnewbd !== "null")
        ? parseInt(objectCur.idnewbd)
        : objectCur.id;
        CollectionService.addFileToEntite(urlApi,userId,idToSend,formData).then((response) => { 
           if(response.error){            
                setToast({ message: response.message , type: 'error' });
           }else{            
                setToast({ message: response.message , type: 'success' });  
                loadListFile();     
           }
           setLoading(false); 
        });

    };

    // Quand on clique sur la zone => ouvre le sélecteur
    const handleClickFile = () => {
        fileInputRef.current.click();
    };

    // Quand un fichier est choisi
    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileName(file);
            uploadFile(file);
        }
    };

    // Quand un fichier est déposé
    const handleDropFile = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) {
            setFileName(file);
            uploadFile(file);
        }
    };

    const handleDragOverFile = (e) => {
        e.preventDefault(); // important pour autoriser le drop
    };

    const deleteFile = (item) => {
        setShowConfirmModal(true);
        setFileCur(item);
    };

    const downloadFile = async (file) => {
        const fileUrl = `${collectionRep}${user_data.account.id}/fichiers_modules_mt/annotations/${file.sha1.substring(0,2)}/${file.sha1}.${file.extension.trim()}`;

        try {
            // Vérifie d'abord que le fichier existe bien
            const response = await fetch(fileUrl, { method: "HEAD" }); // HEAD = on ne télécharge pas le contenu, juste les métadonnées
            if (!response.ok) throw new Error("Fichier introuvable ou accès refusé");

            // Si le fichier existe → l'ouvrir dans un nouvel onglet
            window.open(fileUrl, "_blank"); // ouvre dans une nouvelle page / onglet
        } catch (err) {
            console.error(err);
            setToast({ message: "Impossible d'ouvrir le fichier" , type: 'error' });
        }
    };

    // Retourne la classe FA selon l'extension
    const getFileIconClass = (namefile) => {
        const ext = namefile.split(".").pop().toLowerCase();
        switch (ext) {
        case "pdf":
            return "fa-solid fa-file-pdf";
        case "doc":
        case "docx":
            return "fa-solid fa-file-word";
        case "xls":
        case "xlsx":
            return "fa-solid fa-file-excel";
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
            return "fa-solid fa-file-image";
        case "txt":
            return "fa-solid fa-file-lines";
        default:
            return "fa-solid fa-file";
        }
    };
    
    const columns = [
        { key: 'libelle', label: "Nom "}, 
        {
            key: 'actions',
            sortable: false,
            label: '',
            subColumns: [
                { key: 'action1', label: '' },
                { key: 'action2', label: '' },
            ],
            render: (_, row) =>  [
                <td key={`zoom-${row.id}`} style={{width:'30px'}} className='center-align'>
                    <a onClick={() => downloadFile(row)}>
                        <TooltipForm content={`Télécharger le fichier`}>
                        <i className={`fas fa-download blue-text text-darken-3 ${genStyles.fontSize16}`}></i>
                        </TooltipForm>
                    </a>
                </td>,
                <td key={`delete-${row.id}`} style={{width:'30px'}} className='center-align'>
                    <a onClick={() => deleteFile(row)}>
                        <TooltipForm content={`Supprimer le fichier`}>
                        <i className={`fa-solid fa-trash-can red-text text-darken-2 ${genStyles.fontSize16}`}></i>
                        </TooltipForm>
                    </a>
                </td>,
            ]
        }      
    ];

    const selectAllDataRow  = () => {
        return;
    }

    return (
        <div className={genStyles.editFormSection}>
            <div className={genStyles.titleedsection}>
                <i className={`fa-solid fa-file ${genStyles.fontSize18} ${genStyles.fontSize18} ${genStyles.icomargin}`}></i>
                <span className={`${genStyles.fontSize16} ${genStyles.bold} ${genStyles.bgcolorfirsttext}`}>
                Fichiers
                </span>
            </div>
            {(typeCollection === "collection" || collectioncur?.edit) && (
                <>
            <div
                onClick={handleClickFile}
                onDrop={handleDropFile}
                onDragOver={handleDragOverFile}
                style={{
                border: "1px dashed #aaa",
                borderRadius: "8px",
                padding: "5px",
                textAlign: "center",
                cursor: "pointer",
                background: "#f9f9f9"
                }}
            >
                {fileName
                ? (
                    <div>
                    <i
                        className={`${getFileIconClass(fileName.name)} ${genStyles.fontSize24}`}
                        style={{ color: "#86b9e7" , fontSize : "30px"}}
                    ></i>
                    </div>
                ) : (
                    <div>
                    <i
                        className={`fa-solid fa-cloud-arrow-up `}
                        style={{ color: "#86b9e7", fontSize : "30px" }}
                    ></i>
                    <div className={`italic`}>Cliquez ou glissez-déposez un fichier ici.</div>
                    </div>
                )}
            </div>
            {/* Input caché */}
            <input
                className={genStyles.inputtCol}
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileSelect}
            />
            </>
            )}
            {fichierlist.length > 0 && (
                <div className={genStyles.ctnlistfichier}>
                    <ResultForm 
                        data={fichierlist} 
                        columns={columns} 
                        onSelectRow={selectAllDataRow} 
                        pageSize={10} 
                        tableHeight="300px" 
                        textpaginate="fichiers" 
                        texteSearch="Rechercher un fichier"
                        sortConfig={sortConfig}
                        setSortConfig={setSortConfig}
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                    />
                </div>
            )}

            {showConfirmModal && (
                <FullScreenModal>
                    <DeleteCollectionForm onClose={() => setShowConfirmModal(false)} objectCur={fileCur} type='file' setEntites={setEntites}/>
                </FullScreenModal>
            )}

        </div>
        
    );
}
